// Intercepts raw fetch() calls to Supabase endpoints in demo mode
// Needed for providerOrders.ts, useProviderSelection.ts, and Landing.tsx
// which use fetch() directly instead of the Supabase client

import { edgeFunctionHandlers, rpcHandlers } from './demoData';

let installed = false;

export function installDemoFetchInterceptor(): void {
  if (installed) return;
  installed = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;

    // Match Supabase edge function calls: /functions/v1/<name>
    const fnMatch = url.match(/\/functions\/v1\/([a-z0-9_-]+)/i);
    if (fnMatch) {
      const funcName = fnMatch[1];
      const handler = edgeFunctionHandlers[funcName];
      if (handler) {
        let body: any = {};
        // Parse body from POST requests
        if (init?.body) {
          try { body = JSON.parse(init.body as string); } catch {}
        }
        // Parse query params from GET requests
        try {
          const u = new URL(url);
          u.searchParams.forEach((val, key) => {
            body[key] = val;
          });
        } catch {}

        const result = handler(body);
        return new Response(JSON.stringify(result), {
          status: 200,
          headers: { 'Content-Type': 'application/json' },
        });
      }
    }

    // Match Supabase RPC calls: /rest/v1/rpc/<name>
    const rpcMatch = url.match(/\/rest\/v1\/rpc\/([a-z0-9_-]+)/i);
    if (rpcMatch) {
      const rpcName = rpcMatch[1];
      const handler = rpcHandlers[rpcName];
      if (handler) {
        let params: any = {};
        if (init?.body) {
          try { params = JSON.parse(init.body as string); } catch {}
        }
        const result = handler(params);
        return new Response(JSON.stringify(result), {
          status: 200,
          headers: { 'Content-Type': 'application/json' },
        });
      }
    }

    // Pass through everything else
    return originalFetch(input, init);
  };
}

export function uninstallDemoFetchInterceptor(): void {
  // Note: cannot cleanly restore original fetch if other code also patched it.
  // This is fine because demo mode ends with a page reload via deactivateDemo().
  installed = false;
}
